import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UserService } from './services/user.service';
import { LoaderService } from './services/loader.service';
import { ShopService } from './services/shop.service';
import { HttpClient } from '@angular/common/http';;
import { DomSanitizer } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { AbstractControl, FormBuilder, FormGroup, ValidatorFn, Validators } from "@angular/forms";

@Component({
  selector: 'app-helpdesk',
  templateUrl: '/helpdesk.component.html?v=20260305',
  styles: ['.imgPreview {width: 8em; height: 8em; background-size: contain; background-repeat: no-repeat; background-position: center} .myForm { gap: 0.5em; justify-content: center; .flxRow { display: flex;  flex-direction: row; align-items: center; padding: 0.5em 0; label { min-width: 8.5em; text-align: left; }} } ']
})

export class HelpDeskComponent {

  @Input() buttonType: string = "no type";
  @Input() text: string = "no type";
  @Input() buttonClass: string = "";
  @Input() doHelpDeskNotice: boolean = false
  @Input() shop: any =  [];
  @Input() shopName: string = "";
  @Input() shopBrand: string = "";
  @Output() finished: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Output() claimform: EventEmitter<boolean> = new EventEmitter<boolean>();

  loadingFiles = false;

  public outputFinished() {
    this.finished.emit(true);
  }

  public loadClaimForm() {

    this.claimform.emit(true);

  }

  subscriptions: Subscription[] = []
  helpDeskForm = false;
  myForm: FormGroup;
  myDataSubs: any;
  myUser: any;
  myDataShops: any = null;
    myDataShopsAll: any = [];
    loadingAutocomplete = true;
    dspOrderNumber = false;
    dspCampaignName = false;
    dspHandS = false;
    myMessage = "";
    myCss = "";
    submitForm = false;
    dspPhone = false;
    dspLogged = false;
  stepDisplay = 1;

  userName: string;
  store: any;
  sla: string = "";


  myDataAdditional1 = [{ "Type": "Sending Store" }
    , { "Type": "Receiving Store" }
  ];

  myDataAdditional2 = [{ "Type": "Store" }
    , { "Type": "Customer" }
    , { "Type": "Specsavers Glazing Lab" }
    , { "Type": "Supplier" }
  ];

  myDataBrands = [  { "Name": "SpecSavers" } ];

  //myDataCategories = [];

  myDataCategories = [{ Type: "Non Collection", Problem: "Not Collected" }
    , { Type: "Non Delivery", Problem: "Not Received" }
    , { Type: "Missing Delivery", Problem: "Missing Delivery" }
    , { Type: "Missing Item In Parcel", Problem: "Missing Items" }
    , { Type: "Damaged Item In Parcel", Problem: "Damaged Item In Parcel" }
    , { Type: "Damaged Parcel", Problem: "Damaged Parcel" }
    , { Type: "Delivery Access Amendment", Problem: "Delivery Access Amendment" }
    , { Type: "Site Address Change", Problem: "Site Address Change" }
    , { Type: "Late Delivery", Problem: "Late Delivery" }
    , { Type: "Driver Conduct", Problem: "Driver Conduct" }
    , { Type: "Issue With POD", Problem: "Issue With POD" }
    , { Type: "Delivered To Wrong Location", Problem: "Delivered To Wrong Location" }
     
    , { Type: "General Query", Problem: "General Query" } 
  ];

 

  constructor(private userService: UserService
    , private loaderService: LoaderService
    , private shopService: ShopService
    , public http: HttpClient
    , private fb: FormBuilder
    , private sanitizer: DomSanitizer  ) {

    this.loadForm()

   

  }

    loadForm(myUser: any = null) {
        //this.myFile = { "Filename": "", "Title": "", "Type": "" }; //clear this out each time
        this.dspUploadPending = false;
      this.myForm = this.fb.group({
        /*myFormBrand: [(this.shopBrand ? this.shopBrand : ''), Validators.required],*/
        //myFormShop: [{ value: (this.shopName ? this.shopName : ''), disabled: true }], //, 
        //myFormName: [(myUser ? (myUser.Role.toLowerCase() != 'lbo' ? myUser.Firstname + ' ' + myUser.Lastname : '') : ''), Validators.required],
        myFormName: ['', Validators.required],
        myFormMobile: [''],
        myFormEmail: [{ value: (myUser ? myUser.Email : ''), disabled: true }, [Validators.required, Validators.email]],
        myFormAdditional1: ['', Validators.required],
        myFormAdditional2: [''],
        myFormAdditional3: [''],
        myFormEscalation: [''],
            myFormProblem: ['', Validators.required],
            myFormDetails: ['', Validators.required],
            myFormFiles: [''],
            myFilesPreview: [''],

            fileslist: this.fb.array([]),
            files: this.fb.array([])
        });

      this.myForm.markAsTouched();
      this.myForm.markAsDirty();
      this.onChangeEscalation();
    }

  

    public findInvalidControls() {
        const invalid = [];
        const controls = this.myForm.controls;
        for (const name in controls) {
            if (controls[name].invalid) {
                invalid.push(name);
            }
        }
        return invalid;
  }

  dspAdditional2 = false;
  loadAdditional2($event) {
    let myValue = this.myForm.get("myFormAdditional1").value;

    if (myValue == 'Sending Store') {
      this.dspAdditional2 = true;
      this.myForm.get("myFormAdditional2").setValidators([Validators.required]);
    }
    else {
      this.myForm.get("myFormAdditional2").clearValidators();
      this.myForm.get("myFormAdditional2").setErrors(null);
      this.dspAdditional2 = false;  
    }
    this.myForm.controls['myFormAdditional2'].updateValueAndValidity()

  }

  dspAdditional4 = false;
  loadAdditional4($event) {
    let myValue = this.myForm.get("myFormAdditional2").value;
    if (myValue == 'Store' || myValue == 'Specsavers Glazing Lab' )  {
      this.dspAdditional4 = true;
    }
    else {
      this.dspAdditional4 = false;
    }
  }

  myFormAdditional4: any  = '';

  setShop(shop: any) {
    this.myFormAdditional4 = shop
  }

  getShops() {
    this.loaderService.emitChange(true);
    var myUrl: string = '/Resources2/ShopsList';
    this.subscriptions.push(this.http.get(myUrl).subscribe((res: any) => {
      this.myDataShopsAll = res;
      this.loaderService.emitChange(false);
    }));   
  }

    autocompleListFormatter = (data: any) => {
        return `<b>${data.Key}</b> ${data.Name} ${data.Address1} ${data.City} ${data.PostCode}`
    }

    myValueFormatter(data: any): string {
        return data.Key;
    }

    loadHelpForm() {
        this.helpDeskForm = true;
        this.mySubmissionData = null;
        this.submitForm = false;
        this.loadForm(this.myUser);
    }

    closeHelpDeskForm() {
        this.helpDeskForm = false;
        this.submitForm = false;
    }


    myTxtAreaHeight = "200px"
    txtAreaSize(event: any) {
        let textArea = event.target; //this.myForm.controls['myFormDetails']
        this.myTxtAreaHeight = (textArea.scrollHeight < 250 ? 250 : textArea.scrollHeight) + "px"
    }

    dspAddPicMessage = false;
    myMessageSendFiles = "";
    mySubmissionData: any;
    myResponseTxt = "";
  dspClaimMessage = false; 
    onSubmit(event: any) {
        this.dspAddPicMessage = false
        let doSumbit = true;


        if (doSumbit) { 
            this.loaderService.emitChange(true);
            this.submitForm = true;
            //this.myMessage = "Please wait whilst we upload any attachments and retrieve your case reference.";
          this.myMessage = "Please wait whilst retrieve your case reference.";
          this.myResponseTxt = "";
          this.dspClaimMessage = false;
            //let myVal = this.myForm.get("myFormShop").value
            this.mySubmissionData = {
                "Brand": "Specsavers", //this.myForm.get("myFormBrand").value,
                "Shop": this.myDataShopsAll.filter((itm: any) => itm.Key.toLowerCase() === this.shop.Key.toLowerCase())[0],
              "Name": this.myForm.get("myFormName").value,
              "Mobile": this.myForm.get("myFormMobile").value,
              
                "Email": this.myForm.get("myFormEmail").value,
                "ProblemCategory": this.myForm.get("myFormProblem").value,
                "Additional1": this.myForm.get("myFormAdditional1").value,
                "Additional2": this.myForm.get("myFormAdditional2").value,
                "Additional3": this.myForm.get("myFormAdditional3").value,
                "Additional4": this.myFormAdditional4?.Key,
              "Details": this.myForm.get("myFormDetails").value,
              
              "Escalation": this.myForm.get("myFormEscalation").value,
              "EscalationStore": this.myFormEscalationStore?.Key,
                //"AttachedFiles": JSON.stringify({ "AttachedFiles": this.myFilesPreview }),
                "IncludesAttachments": (this.myFilesPreview.length > 0 ? this.myFilesPreview.length : 0),
               
            }
 
          this.http.post<any>("/HelpDesk/AddQuery25", this.mySubmissionData)
            .subscribe({
              next: (res) => {
                this.loaderService.emitChange(false);

                try {
                  if (res.Result !== "success") {
                    if (res.Message) {
                      this.myMessage = res.Message;
                    } else {
                      this.myMessage = res[0]?.message;
                    }
                    this.myCss = "error";
                  } else {
                    this.outputFinished()

                    this.dspClaimMessage = false;

                    switch (this.mySubmissionData.ProblemCategory) {
                      case 'Not Collected':
                        this.myResponseTxt = "i2i will aim to resolve your case within 2 hours"
                        break;
                      case 'Not Received':
                        this.myResponseTxt = "i2i will aim to resolve your case within 2 hours"
                        break;
                      case 'Missing Delivery':
                        this.myResponseTxt = "";// "i2i will aim to resolve your case within 2 hours"
                        this.dspClaimMessage = true;
                        break;
                      case 'Missing Items':
                        this.myResponseTxt =`If your delivery was received from a <b>UK Manufacturing & Distribution (M&D) site</b>, please follow the process below:<br>
                        <ul>
                        <li>Contact Specsavers Customer Services on 0345 450 0555.</li>
                        <li>Alternatively, email  <a href="mailto:Mdcustomerservice@specsavers.com">Mdcustomerservice&#64;specsavers.com</a>.</li>
                        </ul>
                        Please note that i2i are unable to resolve issues relating to damaged items received from a UK M&D site.<br><br>
                        <b>Deliveries from other sources</b><br>
                        If the item was received from:
                        <ul>
                        <li>Another Specsavers store</li>
                        <li>An offsite lab</li>
                        <li>A supplier</li>
                        </ul>
                        Please contact the sender directly, as they are responsible for investigating and resolving any issues with the shipment.`
                        this.dspClaimMessage = true;
                        break;
                      case 'Damaged Item In Parcel':
                        //this.myResponseTxt = 'If there are any damaged items in your parcel, i2i are unable to resolve this, please contact Specsavers Customer Services on Tel: 0345 450 0555 or Email: <a href="mailto:Mdcustomerservice@specsavers.com">Mdcustomerservice&#64;specsavers.com</a>'
                         this.myResponseTxt =`If your delivery was received from a <b>UK Manufacturing & Distribution (M&D) site</b>, please follow the process below:<br>
                        <ul>
                        <li>Contact Specsavers Customer Services on 0345 450 0555.</li>
                        <li>Alternatively, email  <a href="mailto:Mdcustomerservice@specsavers.com">Mdcustomerservice&#64;specsavers.com</a>.</li>
                        </ul>
                        Please note that i2i are unable to resolve issues relating to damaged items received from a UK M&D site.<br><br>
                        <b>Deliveries from other sources</b><br>
                        If the item was received from:
                        <ul>
                        <li>Another Specsavers store</li>
                        <li>An offsite lab</li>
                        <li>A supplier</li>
                        </ul>
                        Please contact the sender directly, as they are responsible for investigating and resolving any issues with the shipment.`

                        this.dspClaimMessage = true;
                        break;
                      case 'Site Address Change':
                        this.myResponseTxt = 'If you are reporting a Site Address change, i2i are unable to resolve this, please contact the Logistics Team on <a href="mailto:logistics.queries@specsavers.com">logistics.queries&#64;specsavers.com</a>'
                        break;
                      case 'Damaged Parcel':
                        this.myResponseTxt = "";// "i2i will aim to resolve your case within 12 hours"
                        this.dspClaimMessage = true;
                        break;
                      case 'Delivery Access Amendment':
                        this.myResponseTxt = "i2i will aim to resolve your case within 12 hours"
                        break;
                      case 'Late Delivery':
                        this.myResponseTxt = "i2i will aim to resolve your case within 2 hours"
                        break;
                      case 'Driver Conduct':
                        this.myResponseTxt = "i2i will aim to resolve your case within 2 hours"
                        break;
                      case 'Issue With POD':
                        this.myResponseTxt = "i2i will aim to resolve your case within 2 hours"
                        break;
                      case 'Delivered To Wrong Location':
                        this.myResponseTxt = "i2i will aim to resolve your case within 2 hours"
                        break;
                      case 'General Query':
                        this.myResponseTxt = "i2i will aim to resolve your case within 12 hours"
                        break;
                      default:
                        this.myResponseTxt = "P1 - i2i will aim to resolve your case within 2 hours<br>P2 - i2i will aim to resolve your case within 12 hours"
                    }

                    if ((this.myFilesPreview?.length ?? 0) === 0) {
                      this.myMessage = res.Message;
                    } else {
                      const mySubmissionDataFiles = {
                        //AttachedFiles: { AttachedFiles: this.myFilesPreview },
                        AttachedFiles: JSON.stringify({ "AttachedFiles": this.myFilesPreview }),
                        QueryResponseId: res.QueryResponseId
                      };

                      this.myMessage = res.Message;

                      this.stepDisplay = 1


                      this.myMessageSendFiles = "Please wait a moment longer whilst we submit your files.";
                      this.loadingFiles = true;
                      this.myCss = "success";

                      this.loaderService.emitChange(true);

                      this.http.post<any>("/HelpDesk/AddQuery25Files", mySubmissionDataFiles)
                        .subscribe({
                          next: (res2) => {
                            this.loaderService.emitChange(false);
                            this.myFilesPreview = [];

                            try {
                              if (res2.Result !== "success") {
                                if (res2.Message) {
                                  this.myMessageSendFiles = res2.Message;
                                } else {
                                  this.myMessageSendFiles = res2[0]?.message;
                                }
                                this.myCss = "error";
                              } else {
                                this.myMessageSendFiles = res2.Message + " " + res2.Attachments;
                                this.myCss = "success";
                              }
                              this.loadingFiles = false;
                            } catch (e) {
                              this.myMessage = res2 + ".";
                              this.loadingFiles = false;
                            }
                          },
                          error: (error) => {
                            this.myMessage = error + ".";
                            this.loadingFiles = false;
                          }
                        });
                    }
                  }
                } catch (e) {
                  this.myMessage = res + ".";
                }
              },
              error: (error) => {
                this.myMessage = error + ".";
              }
            });


           
           
        }
    }



    getCatTitle(name: string) {
        let myReturn = name
        this.myDataCategories.forEach((itm: any) => {
            if (itm.Name == name) {
                myReturn = itm.Title
            }
        })
        return myReturn
    }



    //BEGIN FILE UPLOAD

    previewPic(myPic: string) {
        if (myPic === "no_image") {
            myPic = null;
        }
        return this.sanitizer.bypassSecurityTrustStyle("url(\"" + myPic + "\")");
    }

    removeFile(i: number) {
        //this.myFiles.splice(i, 1);
        this.myFilesPreview.splice(i, 1);

        //this.dspTooLarge = false;
        //let myFilesCombinedSize = 0;
        //this.myFilesPreview.forEach((itm: any) => {
        //    myFilesCombinedSize += itm.Size;
        //});

        //if (myFilesCombinedSize > this.maxFileSize) {
        //    //this.myLargeFiles.push({ "file": fileData.name, "size": fileData.size });
        //    this.dspTooLarge = true
        //}

        this.getFileSizes();

    }

    getFileSizes() {
   
        this.dspTooLarge = false;
        let myFilesCombinedSize = 0;
        this.myFilesPreview.forEach((itm: any) => {
            myFilesCombinedSize += itm.Size;
        });

        if (myFilesCombinedSize > this.maxFileSize) {
          this.dspTooLarge = true;
         
        }

    }

    //myFile = { "Filename": "", "Title": "", "Type": "" }; //clear this out each time
    dspUploadPending = false;

    myFiles: string[] = [];
    myFilesPreview: any = [];
    //fileData: File = null;
    myMimeTypes = [""
        ,"image/jpeg"
        ,"image/png"
        ,"application/pdf"
        ,"text/csv"
        ,"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        , "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        , "video/mp4"
        , "video/webm"
        , "video/ogg"
        , "video/x-msvideo"
        , "video/quicktime"
        , "video/x-flv"
        , "video/x-ms-wmv"
    ]

    getBase64(file: any) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                let encoded = reader.result.toString().replace(/^data:(.*,)?/, '');
                if ((encoded.length % 4) > 0) {
                    encoded += '='.repeat(4 - (encoded.length % 4));
                }
                resolve({ "Clean": encoded, "Meta": reader.result.toString() });
            };
            reader.onerror = error => reject(error);
        });
    }

   
   // myLargeFiles: any = [];
    maxFileSize = 40 * 1024 * 1024;
    dspTooLarge = false;

     bytesToMB(bytes: number): number {
    const megabytes = bytes / (1024 * 1024); // Convert bytes to MB
        return Math.round(megabytes); // Round to 0 decimal places
    }
    
    fileSelectHandler(event: any) { //this one for the fiel select// could deal with multiple files (restricted by input)
        this.myForm.markAsTouched();
        this.myForm.markAsDirty();
        this.myFiles = [];

       // this.myLargeFiles = []

        let myFilesCombinedSize = 0;

        for (let x: number = 0; x < event.target.files.length; x++) {
            //preview // we want to encourage the upload so no preview
            let fileData: File = <File>event.target.files[x];
            let mimeType: string = fileData.type;

            let myFile = null;
         
            if (this.myMimeTypes.findIndex(x => x === mimeType) > -1) {

               // myFilesCombinedSize += fileData.size

                //if (fileData.size > this.maxFileSize) {
                 //   this.myLargeFiles.push(fileData.name);
                //}

                //this.myLargeFiles.push({ "file": fileData.name, "size": fileData.size / 1024+ 'MB' });

               // if (myFilesCombinedSize > this.maxFileSize) {
                    //this.myLargeFiles.push({ "file": fileData.name, "size": fileData.size });
                  //  this.dspTooLarge = true
                //}
     
                this.getBase64(fileData).then(
                    (data: any) => {
                        if (mimeType.match(/image\/*/) == null) {
                            myFile = { "Filename": event.target.files[x].name, "Title": event.target.files[x].name, "Size": event.target.files[x].size , "Type": event.target.files[x].type, "File": "", "Base64": data.Clean, "Display": "File" };
                        }
                        else {
                            myFile = { "Filename": event.target.files[x].name, "Title": event.target.files[x].name, "Size": event.target.files[x].size, "Type": event.target.files[x].type, "File": data.Meta, "Base64": data.Clean, "Display": "Image" };
                        }
                        this.myFilesPreview.push(myFile);

                        this.getFileSizes() 
                    }
                );


                
            }
            else {
                return;//nothing
            }



        }


        

        this.dspUploadPending = true;
    }


  dspEscalation = false;
  isEscalation = false;

  onChangeEscalation() {
    this.isEscalation = this.myForm.get("myFormEscalation").value
  }

  myFormEscalationStore: any = '';

  setEscalation(shop: any) {
    this.myFormEscalationStore = shop;
  }



    //END FILE UPLOAD
    public ngOnInit(): any {
      this.submitForm = false;
      this.stepDisplay = 1
      this.getShops();
      this.store = this.shopName;
      //this.sla = this.Sla
      this.subscriptions.push(this.userService.profile().subscribe((data: any) => {
            this.myUser = data;
        })
      )

      this.dspEscalation = (['8000', '8001', '9999'].includes(this.shop.Key));
      //this.dspEscalation = (['9999'].includes(this.shop.Key));
      
    }

    public ngOnDestroy() {
        this.subscriptions.forEach((subscription) => { subscription.unsubscribe(); });
    }

}
